import useUser from "@hooks/useUser"

import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

export default function BillTableView() {
    const { user } = useUser()

    return (
        <TableView.Table>
            <Table.Column<Bill>
                accessorKey="id"
                header="ID"
                size={144}
                cell={({ row }) => <Table.Cells.IDCell id={row.original.custom_id || row.original.id} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Bill>
                accessorKey="status_label"
                header="Status"
                size={176}
                cell={({ getValue }) => <Table.Cells.StatusCell objectType="bill" status={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Bill>
                accessorKey="state_label"
                header="State"
                size={176}
                cell={({ getValue }) => <Table.Cells.BadgesCell badges={[getValue()]} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Bill>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as BillLabel[])?.map((label: BillLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Bill>
                accessorKey="subtotal"
                header="Total"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            {user?.service_company?.feature_vendor_credits_enabled && (
                <Table.Column<Bill>
                    accessorKey="amount_due"
                    header="Amount Due"
                    size={144}
                    cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                    enableSorting={true}
                    enablePinning={false}
                    dataType="numerical"
                    alignment="right"
                />
            )}
            <Table.Column<Bill>
                accessorKey="vendor_name"
                header="Billing Vendor"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Bill>
                accessorKey="vendor_invoice_id"
                header="Vendor Invoice ID"
                size={200}
                cell={({ getValue }) => <Table.Cells.IDCell id={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Bill>
                accessorKey="date_due"
                header="Due Date"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Bill>
                accessorKey="last_status_transition_time"
                header="Status Changed"
                size={160}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={false}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Bill>
                accessorKey="last_modified_at"
                header="Last Modified"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Bill>
                accessorKey="last_received_at"
                header="Received"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Bill>
                accessorKey="last_paid_at"
                header="Paid"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Bill>
                accessorKey="last_voided_at"
                header="Voided"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
